/*
 * @Descripttion:
 * @version:
 * @Author: baoyb
 * @Date: 2019-08-05 10:04:30
 * @LastEditors: zhaohuimin
 * @LastEditTime: 2020-09-28 15:21:39
 */
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    if (time === null) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        var mb = myBrowser()
        if (typeof mb === 'undefined' || mb === 'IE') {
            if (stringToDate(time) === null) {
                return null
            } else {
                date = stringToDate(time)
            }
        } else {
            date = new Date(time)
        }
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

// 时间组件快捷部分
export const pickerOptions = {
    shortcuts: [{
        text: '最近一周',
        onClick(picker) {
            picker.$emit('pick', [recentWeek(), todayEnd()])
        }
    }, {
        text: '最近一个月',
        onClick(picker) {
            picker.$emit('pick', [recentMonth(), todayEnd()])
        }
    }, {
        text: '最近三个月',
        onClick(picker) {
            picker.$emit('pick', [recentThreeMonth(), todayEnd()])
        }
    }]
}

// 今天起止
import moment from 'moment'
export function wxtime(val) {
    return moment(val).format("YYYY-MM-DD")
}
export function NowTime() {
    return moment().format('YYYY-MM-DD hh:mm:ss')
}

// 今天开始
export function todayStart() {
    return moment().format('YYYY-MM-DD 00:00:00')
}
// 今天的结束
export function todayEnd() {
    return moment().format('YYYY-MM-DD 23:59:59')
}

// 最近一周的第一天
export function recentWeek() {
    return moment().subtract(1, 'weeks').format('YYYY-MM-DD 00:00:00')
}

// 最近一个月的第一天
export function recentMonth() {
    return moment().subtract(1, 'months').format('YYYY-MM-DD 00:00:00')
}

// 最近三个月的第一天
export function recentThreeMonth() {
    return moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00')
}

// 本周的第一天
export function weekStart() {
    return moment().startOf('week').format('YYYY-MM-DD 00:00:00')
}

// 本周的最后一天
export function weekEnd() {
    return moment().endOf('week').format('YYYY-MM-DD 23:59:59')
}
// 本月第一天
export function showMonthFirstDay() {
    return moment().startOf('month').format('YYYY-MM-DD 00:00:00')
}

// 本月最后一天
export function showMonthLastDay() {
    return moment().endOf('month').format('YYYY-MM-DD 23:59:59')
}

// 兼容ie
function stringToDate(fDate) {
    if (typeof fDate === 'undefined') {
        return null
    }
    fDate = fDate.replace('T', ' ').replace('Z', ' ')
    var fullDate = fDate.split(' ')[0].split('-')
    var fullTime = fDate.split(' ')[1].split(':')
    return new Date(fullDate[0], fullDate[1] - 1, fullDate[2], (fullTime[0] != null ? parseInt(fullTime[0]) + 8 : 0), (fullTime[1] != null ? fullTime[1] : 0), (fullTime[2] != null ? fullTime[2] : 0))
}

// 判断浏览器版本
function myBrowser() {
    var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf('Opera') > -1
    if (isOpera) {
        return 'Opera'
    } // 判断是否Opera浏览器
    if (userAgent.indexOf('Firefox') > -1) {
        return 'FF'
    } // 判断是否Firefox浏览器
    if (userAgent.indexOf('Chrome') > -1) {
        return 'Chrome'
    }
    if (userAgent.indexOf('Safari') > -1) {
        return 'Safari'
    } // 判断是否Safari浏览器
    if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('msie') > -1 && !isOpera) {
        return 'IE'
    } // 判断是否IE浏览器
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i)
        if (code > 0x7f && code <= 0x7ff) s++
        else if (code > 0x7ff && code <= 0xffff) s += 2
        if (code >= 0xDC00 && code <= 0xDFFF) i--
    }
    return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
    if (!json) return ''
    return cleanArray(
        Object.keys(json).map(key => {
            if (json[key] === undefined) return ''
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
        })
    ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')
            .replace(/\+/g, ' ') +
        '"}'
    )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
    if (typeof target !== 'object') {
        target = {}
    }
    if (Array.isArray(source)) {
        return source.slice()
    }
    Object.keys(source).forEach(property => {
        const sourceProperty = source[property]
        if (typeof sourceProperty === 'object') {
            target[property] = objectMerge(target[property], sourceProperty)
        } else {
            target[property] = sourceProperty
        }
    })
    return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
    if (!element || !className) {
        return
    }
    let classString = element.className
    const nameIndex = classString.indexOf(className)
    if (nameIndex === -1) {
        classString += '' + className
    } else {
        classString =
            classString.substr(0, nameIndex) +
            classString.substr(nameIndex + className.length)
    }
    element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
    if (type === 'start') {
        return new Date().getTime() - 3600 * 1000 * 24 * 90
    } else {
        return new Date(new Date().toDateString())
    }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function (...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
    return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
    if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}

export function MergeArray(arr1, arr2) {
    var _arr = []
    for (var k = 0; k < arr1.length; k++) {
        _arr.push(arr1[k])
    }
    for (var i = 0; i < arr2.length; i++) {
        var flag = true
        for (var j = 0; j < arr1.length; j++) {
            if (arr2[i].id === arr1[j].id) {
                flag = false
                break
            }
        }
        if (flag) {
            _arr.push(arr2[i])
        }
    }
    return _arr
}

export function DeleteArray(arr1, arr2) {
    var _arr = []
    for (var k = 0; k < arr1.length; k++) {
        _arr.push(arr1[k])
    }
    for (var i = 0; i < _arr.length; i++) {
        for (var j = 0; j < arr2.length; j++) {
            if (_arr[i]) {
                if (arr2[j].id === _arr[i].id) {
                    _arr[i] = ''
                }
            }
        }
    }
    _arr.forEach((item, index) => {
        if (item === '') {
            _arr.splice(index, 1)
        }
    })
    console.log('_arr')
    console.log(_arr)
    return _arr
}

export function DeleteArray_(arr1, arr2) {
    arr1 = arr1.filter(item => {
        let flag = true
        arr2.forEach(v => {
            if (v.id === item.id) {
                flag = false
            }
        })
        if (flag === true) {
            return item
        }
    })
    return arr1
}



// WEBPACK FOOTER //
// ./src/utils/index.js